const CLIENT_ID_KEY = "bp_client_id";

function randomHex(len: number): string {
  const bytes = new Uint8Array(Math.ceil(len / 2));
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, len);
}

function createFallbackId(): string {
  return `${Date.now().toString(36)}-${randomHex(16)}`;
}

export function getClientId(): string {
  const existing = (localStorage.getItem(CLIENT_ID_KEY) || "").trim();
  if (existing) return existing;

  const id = typeof crypto.randomUUID === "function" ? crypto.randomUUID() : createFallbackId();
  localStorage.setItem(CLIENT_ID_KEY, id);
  return id;
}

